import LinkIcon from "@src/app/assets/icons/link.svg?react";
import TickIcon from "@src/app/assets/icons/tick.svg?react";
import Button from "@src/app/components/Button/Button";
import viewportState from "@src/app/stores/viewport";
import cx from "classnames";
import { type ReactElement } from "react";

interface Props {
  isVideoArticle?: boolean;
  articleUrl?: string;
  setHasCopiedLink: (value: boolean) => void;
  hasCopiedLink: boolean;
  theme?: "light" | "dark";
}

export default function CopyLinkButton({
  isVideoArticle,
  articleUrl,
  setHasCopiedLink,
  hasCopiedLink,
  theme = "light",
}: Props): ReactElement {
  // const [hasCopiedLink, setHasCopiedLink] = useState(false);
  const { isMobileView, isMobileOrTabletDevice } = viewportState;
  const currentUrl = isVideoArticle
    ? (articleUrl ?? "")
    : typeof window !== "undefined"
      ? window.location.href
      : "";

  const copyLink = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        setHasCopiedLink(true);
      })
      .catch((err) => {
        console.error("Failed to copy URL:", err);
      });

    setTimeout(() => {
      setHasCopiedLink(false);
    }, 3000);
  };

  return (
    <div id="copy-link-button">
      <Button
        variant={theme === "light" ? "tertiary" : "secondary"}
        size="medium"
        icon={<LinkIcon width={20} height={20} />}
        onClick={copyLink}
      />

      {hasCopiedLink && (
        <div
          style={
            isMobileView && isMobileOrTabletDevice
              ? {
                  bottom: `calc(env(safe-area-inset-bottom) + 20px)`,
                  left: "20px",
                  right: "20px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }
              : isMobileOrTabletDevice
                ? {
                    bottom: `calc(env(safe-area-inset-bottom) + 20px)`,
                    left: "20px",
                    width: "319px",
                  }
                : {}
          }
          className={cx(
            // Base styles
            "text-label-2 z-100 flex flex-nowrap items-center gap-2.5 rounded-sm bg-white py-2 pr-3.5 pl-2 font-bold shadow-md",

            {
              // Mobile & Tablet Device Postion
              fixed: isMobileOrTabletDevice,

              // Desktop only Position
              "fixed w-[90%] md:w-75": !isMobileOrTabletDevice,

              // Desktop full toast
              "animate-fade-in-up right-0 bottom-4 left-0 mx-auto md:left-6 md:mx-0":
                !isMobileOrTabletDevice,
            },
          )}
        >
          <TickIcon className="text-secondary" width={24} height={24} />
          <span className="text-secondary font-bold">Link Copied</span>
        </div>
      )}
    </div>
  );
}
